; ( async ( postId ) => {
	// initial setup 
	// address bar query parameter for pagination
	const pageQueryParam = "n";

	// set state
	let state = {
		loggedIn: false,
		ogLoadedPostId: postId,
		currPage: 0,
		currChapter: 0,
		onLastPage: false,
		onFirstPage: true,
		onFirstChapter: true,
		onLastChapter: false,
	}

	state.chapters = await loadChapterData;
	state.totalChapters = state.chapters.length;
	state.totalPages = countTotalPages();
	// html templates
	const chapterTemplate = document.getElementById( 'chapterTemplate' ).content;
	const standardTemplate = document.getElementById( 'standardTemplate' ).content;
	const bleedTemplate = document.getElementById( 'bleedTemplate' ).content;
	const noPageFoundTemplate = document.getElementById( 'noPageFoundTemplate' ).content;

	// grab elements we'll need
	const bookContainer = document.getElementById( 'book-container' );
	const chapterContainer = document.getElementById( 'chapter-container' );
	const chapterTitleEl = document.getElementById( 'chapter-title' );
	const chapterSubtitleEl = document.getElementById( 'chapter-subtitle' );
	const prevBtn = document.getElementById( 'prevPageBtn' );
	const nextBtn = document.getElementById( 'nextPageBtn' );
	const root = document.documentElement;



	// load initial page - use query param if available
	const pageQueried = Number( new URLSearchParams( window.location.search ).get( pageQueryParam ) );
	state.currPage = ( pageQueried > 0 ) ? pageQueried - 1 : 0
	// set state.currChapter on load
	state.chapters.find( ( item, i ) => {
		item.id === postId ? state.currChapter = i : null;
	} )

	function countTotalPages() {
		return state.chapters.reduce( ( prev, curr ) => {
			return prev + curr.acf.flexible_content.length
		}, 0 );
	}

	function passwordPrompt() {
		if ( !state.loggedIn ) {
			let sign = prompt( "Password" );
			let n = 0;
			while ( !state.loggedIn ) {
				n++;
				if ( sign === "eroded" ) {
					state.loggedIn = true;
				} else {
					if ( n > 4 ) {
						alert( 'You should probably check the password and try again later.' )
					}
					sign = prompt( "Try again. Password" )
				}
			}
		}
	}

	function loadPage( chapter = 0, page = 0, loadHistory, direction ) {

		//passwordPrompt();


		prevBtn.classList.add( 'is-disabled' );
		nextBtn.classList.add( 'is-disabled' );
		prevBtn.setAttribute( 'disabled', '' );
		nextBtn.setAttribute( 'disabled', '' );
		// load html templates into memory
		const layouts = {
			chapter: document.importNode( chapterTemplate, true ),
			standard: document.importNode( standardTemplate, true ),
			bleed: document.importNode( bleedTemplate, true ),
			noPageFound: document.importNode( noPageFoundTemplate, true )
		}

		// setup current page data
		const chapterData = state.chapters[chapter];
		const pageData = chapterData.acf.flexible_content[page];
		const template = pageData ? layouts[pageData.acf_fc_layout] : layouts['noPageFound'];
		state.totalChapterPages = chapterData.acf.flexible_content.length;


		// load html from data into correct template layout
		if ( pageData ) {
			if ( template.querySelector( '.template--imageWrap' ) ) {
				if ( pageData.image ) {
					const imgWrap = template.querySelector( '.template--imageWrap' );
					const img = document.createElement( 'img' );
					img.onload = function () {
						this.classList.add( 'faded-in' );
					}
					imgWrap.style.display = "block"; // if we have an image show its wrapper
					img.classList.add( 'fade-in', 'template--image' )
					img.src = pageData.image.url;
					img.width = pageData.image.width;
					img.height = pageData.image.height;
					pageData.image.alt && ( img.alt = pageData.image.alt );
					img.style.aspectRatio = `${img.width}/${img.height}`;
					// imgWrap.style.aspectRatio = `${img.width}/${img.height}`;
					imgWrap.append( img )
				}
			}

			if ( pageData.content && template.querySelector( '.template--content' ) )
				template.querySelector( '.template--content' ).innerHTML = pageData.content;

			if ( template.querySelector( '.template--sub-content' ) && pageData.sub_text )
				template.querySelector( '.template--sub-content' ).innerHTML = pageData.sub_text;
		}

		// clear the screen - change this for animated screen changes
		chapterContainer.innerHTML = "";
		// print html to screen
		chapterContainer.append( template );

		bookContainer.classList = `book-container ${direction || ''} ${pageData ? pageData.acf_fc_layout : "404"}-layout`;
		// update page title
		chapterTitleEl.innerText = chapterData.title.rendered;
		chapterSubtitleEl.innerHTML = chapterData.acf.sub_title ? `<&emsp13;${chapterData.acf.sub_title}&emsp13;>` : "";

		// browser things
		document.title = `${chapterData.title.rendered} - ${state.currChapter}.${state.currPage + 1} / ${state.totalChapters - 1} `;
		if ( loadHistory ) {
			// push state
			history.pushState( state, '', `/chapter/${state.chapters[chapter].slug}/?${pageQueryParam}=${page + 1}` )
		} else {
			// replace state 
			history.replaceState( state, '', `/chapter/${state.chapters[chapter].slug}/?${pageQueryParam}=${page + 1}` )
		}



		updatePageState();
		updateNavBtnStatus();

		responsiveIframes.all();
		document.dispatchEvent( new CustomEvent( 'pageLoad', { detail: { chapterData } } ) );
		document.querySelector( 'body' ).focus();
		window.scrollTo( 0, 0 );
	} // end loadPage

	function onLastPage( currPage = state.currPage, totalChapterPages = state.totalChapterPages ) {
		// return (state.currPage + 1 === state.totalChapterPages);
		return currPage + 1 === totalChapterPages
	}

	function updatePageState() {
		// update pages
		state.onLastPage = onLastPage();//(state.currPage + 1 === state.totalChapterPages) ? true : false;
		state.onFirstPage = ( state.currPage === 0 ) ? true : false;
		// update chapters
		state.onLastChapter = ( state.currChapter + 1 === state.totalChapters ) ? true : false;
		state.onFirstChapter = ( state.currChapter === 0 ) ? true : false;
		// update progress bar
		root.style.setProperty( '--erosion-bookProgress', `${( ( state.currChapter + 1 ) / state.totalChapters ) * 100}%` );
		root.style.setProperty( '--erosion-chapterProgress', `${( ( state.currPage + 1 ) / state.totalChapterPages ) * 100}%` );
	}

	function handleArrowClick( e ) {
		( e.target.id === 'nextPageBtn' ) && getNextPage();
		( e.target.id === 'prevPageBtn' ) && getPrevPage();
		( e.target.hasAttribute( 'data-chapter-index' ) ) && goToChapter( e );
	}

	function handleKeyPress( e ) {
		( e.key === "ArrowRight" ) && getNextPage();
		( e.key === "ArrowLeft" ) && getPrevPage();
	}
	function updateNavBtnStatus() {
		setTimeout( () => {
			prevBtn.removeAttribute( 'disabled' );
			nextBtn.removeAttribute( 'disabled' );

			state.onLastPage && state.onLastChapter
				? nextBtn.classList.add( 'is-hidden' )
				: nextBtn.classList.remove( 'is-hidden' );
		}, 600 )
	}
	function getNextPage() {
		if ( state.onLastPage ) {
			// exit if on last chapter && last page
			if ( state.onLastChapter ) return;
			state.currChapter++;
			state.currPage = -1; // -1 so when +1 below we get to 0
		}
		state.currPage++;
		loadPage( state.currChapter, state.currPage, true, 'forwards' );
	}

	function getPrevPage() {
		if ( state.onFirstPage ) {
			if ( state.onFirstChapter ) {
				// back to home page
				location.href = "/";
				return;
			}
			// get previous chapter
			state.currChapter--;
			// get last page from previous chapter
			const lastPageOfLastChapter = state.chapters[state.currChapter].acf.flexible_content.length
			state.currPage = lastPageOfLastChapter;
		}

		state.currPage--;

		loadPage( state.currChapter, state.currPage, true, 'backwards' );
	}

	function goToChapter( e ) {
		e.preventDefault();
		const index = Number( e.target.getAttribute( 'data-chapter-index' ) );
		state.currChapter = index;
		state.currPage = 0;
		loadPage( state.currChapter, state.currPage, true );
		togglePullout( 'pulloutNav_container', 'off' );

	}

	// loadPage on load
	loadPage( state.currChapter, state.currPage, false );

	// listeners
	document.addEventListener( 'click', throttle( handleArrowClick, 850 ) );
	document.addEventListener( 'keydown', throttle( handleKeyPress, 850 ) );

	// document.addEventListener( 'erosionSwipe', e => {
	// 	if ( e.detail.direction === "right" ) {
	// 		getPrevPage();
	// 	}
	// 	if ( e.detail.direction === "left" ) {
	// 		getNextPage();
	// 	}
	// } )
	window.addEventListener( 'popstate', e => {
		state = e.state;
		loadPage( e.state.currChapter, e.state.currPage, false )
	} )
} )( postId );



